'use client';

import { zodResolver } from '@hookform/resolvers/zod';

// In this precise case we need to retrieve the params aswell
// We cannot guess which one it'll be so we avoid complexity by using the
// next-navigation one
// eslint-disable-next-line no-restricted-imports
import { usePathname } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { useForm } from 'react-hook-form';

import { Button } from '@/app/_components/ui/button';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from '@/app/_components/ui/form';

import { Input } from '@/app/_components/ui/input';

import analyticsManager from '@/lib/analytics';

import redirectToAuthFromEmail from './actions';
import { HeroFormData, heroFormSchema } from './types';

interface FormEmailToRegisterProps {
  ctaLabel: string;
  lightVersion?: boolean;
}

const FormEmailToRegister = ({
  ctaLabel,
  lightVersion,
}: FormEmailToRegisterProps) => {
  const t = useTranslations();
  const pathname = usePathname();

  const onSubmit = (values: HeroFormData) => {
    analyticsManager.client.sendEvent({
      event: 'email_collect',
    });
    redirectToAuthFromEmail(values, pathname);
  };

  const form = useForm<HeroFormData>({
    resolver: zodResolver(heroFormSchema(t)),
    defaultValues: {
      email: '',
    },
  });

  return (
    <Form {...form}>
      <form
        className="w-full max-w-md self-center xl:self-start"
        onSubmit={form.handleSubmit(onSubmit)}
      >
        <FormField
          control={form.control}
          name="email"
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <div className="flex gap-2">
                  <Input
                    className="h-auto bg-white leading-5"
                    placeholder={t('auth.email')}
                    {...field}
                  />
                  <Button
                    variant={lightVersion ? 'light' : 'default'}
                    className="shrink-0"
                    size="lg"
                    type="submit"
                  >
                    {ctaLabel}
                  </Button>
                </div>
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </form>
    </Form>
  );
};

export default FormEmailToRegister;
